import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { KnowledgeSetupPermissionsResponse } from './KnowledgeSetupPermissions.types.tsx';

export const servicedeskKnowledgeBasePermissionsResource: RouteResource<KnowledgeSetupPermissionsResponse> =
	createResource<KnowledgeSetupPermissionsResponse>({
		type: 'SERVICEDESK_KNOWLEDGE_BASE_PERMISSIONS',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-knowledge-base-permissions", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-permissions" */ './getKnowledgeSetupPermissions.tsx'
			),
		maxAge: 30 * 60 * 1000, // 30 minutes
		isBrowserOnly: true,
	});
